/* global I18n, document, console */
import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
} from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { onError } from '@apollo/client/link/error';
import createUploadLink from 'apollo-upload-client/public/createUploadLink.js';
import introspectionQueryResultData from './fragmentTypes.json';
import * as Sentry from '@sentry/browser';

const authLink = new ApolloLink((operation, forward) => {
  const TOKEN = document.querySelector('meta[name="jwt"]')?.getAttribute('content');
  const CSRF = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      Authorization: TOKEN,
      'X-CSRF-TOKEN': CSRF,
    },
  }));

  return forward(operation);
});


const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
      Sentry.captureMessage(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
    });
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
    Sentry.captureException(networkError);
  }
});

const uploadLink = createUploadLink({
  uri: `/${I18n.locale}/api/graphql`,
  credentials: 'include',
});

const retryLink = new RetryLink();

const link = ApolloLink.from([
  retryLink,
  authLink,
  errorLink,
  uploadLink,
]);


//  CACHE
const cache = new InMemoryCache({
  possibleTypes: introspectionQueryResultData.possibleTypes
});


// CLIENT
const apiClient = new ApolloClient({
  link,
  cache,
});

// for debugging
if (process.env.NODE_ENV === 'development') {
  window.__APOLLO_CLIENT__ = apiClient;
}

export default function getApiClient() {
  return apiClient;
}
